import { CancelBtn } from 'components/Button/CancelBtn'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Animation, Button, ButtonsContainer, ItemsGrid, TabFooter } from 'styling/GlobalStyles'
import { ILocationState } from 'types/locations.interface'
import { standardFieldValidation, validateSelect, validationWithCoordinates } from 'utils/validationUtils'

export const LocationSpecificationTab = ({ state, setState, handleSubmit, setInvalidFields, invalidFields }: ILocationSpecificationTab) => {

    const { machineryCategoriesForSelect } = useSelector((store: RootState) => store.machineryCategories)

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const name = (e.target as HTMLInputElement).name.split('-')
        const { value, type } = e.target as HTMLInputElement

        if (name[0] === 'coordinates') {
            validationWithCoordinates(e, setInvalidFields)
            setState((prev) => {
                const copy = { ...prev }
                copy.coordinates[name[1]] = value
                return copy
            })
            return
        }
        standardFieldValidation(e, setInvalidFields)
        setState({
            ...state,
            [(e.target as HTMLInputElement).name]: type === 'text' ? value : Number(value),
        })
    }

    const handleSelect = (value: ISelectValue, name: string) => {
        if (name === 'type') {
            setInvalidFields((prev: string[]) => {
                let copy = [...prev]
                if (value.label === 'static') {
                    copy = copy.filter((f: string) => !f.includes('machinery'))
                    copy = [...copy, 'coordinates-longitude', 'coordinates-latitude']
                } else {
                    copy = copy.filter((f: string) => !f.includes('coord'))
                    copy = [...copy, 'machinery']
                }
                return copy
            })
        }
        validateSelect(value, name, setInvalidFields)
        setState({ ...state, [name]: value.value })
    }
    const locationType = [
        {
            value: 'static',
            label: 'static',
        },
        // { value: 'mobile', label: 'mobile' },
    ]

    const machinesOptions = [{ value: 2, label: 'Machine 1' }]

    return <Animation>
        <ItemsGrid columns={3} >
            <Input
                placeholder='Enter name of location'
                labelText='Location Name'
                name='name'
                value={state.name}
                invalid={invalidFields.includes('name') ? 'true' : ''}
                onChange={handleChange}
            />
            <HonestSelectInput
                options={locationType}
                labelText='Location Type'
                name='type'
                invalid={invalidFields.includes('type') ? 'true' : ''}
                defaultValue={state.type}
                onChange={handleSelect}
            />
            {state.type === 'static' ? (
                <>
                    <Input
                        placeholder='Enter latitude'
                        labelText='Latitude'
                        type='text'
                        name='coordinates-latitude'
                        value={state.coordinates.latitude}
                        onChange={handleChange}
                        invalid={invalidFields.includes('coordinates-latitude') ? 'true' : ''}
                    />
                    <Input
                        placeholder='Enter longitude'
                        labelText='Longitude'
                        type='text'
                        name='coordinates-longitude'
                        value={state.coordinates.longitude}
                        invalid={invalidFields.includes('coordinates-longitude') ? 'true' : ''}
                        onChange={handleChange}
                    />
                    <Input
                        placeholder='Enter location area size'
                        labelText='Location Area Size'
                        name='areaSize'
                        type='number'
                        value={state.areaSize}
                        onChange={handleChange}
                        invalid={invalidFields.includes('areaSize') ? 'true' : ''}
                    />
                </>
            ) : (
                <>
                    <HonestSelectInput
                        labelText='Machinery Categories'
                        options={machineryCategoriesForSelect} // TODO: Probati da se zameni sa Async
                        defaultValue={state.machineryCategory}
                        name='machineryCategory'
                        onChange={(type: ISelectValue, name: string) => handleSelect(type, name)}
                        invalid={invalidFields.includes('machineryCategory') ? 'true' : ''}
                    />
                    <HonestSelectInput
                        labelText='Machinery'
                        options={machinesOptions}
                        defaultValue={state.machinery}
                        name='machinery'
                        onChange={(type: ISelectValue, name: string) => handleSelect(type, name)}
                        invalid={invalidFields.includes('machinery') ? 'true' : ''}
                    />
                </>
            )}
        </ItemsGrid>
        <TabFooter>
            <ButtonsContainer>
                <CancelBtn />
                <Button orange onClick={handleSubmit} type='button'>
                    Save
                </Button>
            </ButtonsContainer>
        </TabFooter>
    </Animation>


}

export interface ILocationSpecificationTab {
    state: ILocationState
    invalidFields: string[]
    setState: React.Dispatch<React.SetStateAction<ILocationState>>
    handleSubmit: () => void
    setInvalidFields: React.Dispatch<React.SetStateAction<string[]>>
}